import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { handleGetBasicInfo, handleSaveBasicInfo } from './BasicOperation';

const BasicSettingContext = createContext();

export const useBasicSetting = () => useContext(BasicSettingContext);

function BasicSettingProvider({ children }) {
    const { setMessage } = useTemplate();
    const [reloadKey, setReloadKey] = useState(0);
    const [propertyName, setPropertyName] = useState('');
    // --Modal open handler
    const [showModal, setShowModal] = useState({
        type: ''
    });
    const [formData, setFormData] = useState({
        loginSessionDuration: 0,
        loggingInMultipleBrowser: false,
        defaultVatPercent: 0,
        gitHubPatToken: '*************',
        smtpConfig: 'Not Configured'
    });
    useEffect(() => {
        handleGetBasicInfo()
            .then(({ data }) => {
                setFormData(data);
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err?.toString(0) });
            });
    }, [setMessage, reloadKey]);

    const value = useMemo(() => {
        // --Handle Reload
        const handleReload = () => {
            setReloadKey((d) => d + 1);
        };

        // --Handle edit click
        const handleEditClick = (name) => {
            setPropertyName(name);
        };
        // --Handle edit click
        const handleCancelEditClick = () => {
            setFormData({});
            setPropertyName('');
        };

        // --handler to set input value to state
        const handleChange = (e) => {
            const { name, value: val } = e.target;
            if (name) {
                setFormData((prev) => ({ ...prev, [name]: val }));
            }
        };
        const handleSaveClick = (type) => {
            handleSaveBasicInfo(type, formData)
                .then(({ title: resTitle }) => {
                    setMessage({ type: 'success', text: resTitle });
                    handleCancelEditClick();
                    handleReload();
                })
                .catch((error) => {
                    setMessage({ type: 'error', text: error?.toString(0) });
                });
        };

        return {
            setReloadKey,
            // --input property name
            propertyName,
            formData,
            handleChange,
            handleEditClick,
            handleCancelEditClick,
            handleSaveClick,
            showModal,
            setShowModal,

            // handler for reload
            handleReload
        };
    }, [formData, propertyName, setMessage, showModal]);

    return <BasicSettingContext.Provider value={value}>{children}</BasicSettingContext.Provider>;
}

export default BasicSettingProvider;
